var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.66 22.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#fff;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.33,1.49a9.84,9.84,0,1,0,9.83,9.84,9.86,9.86,0,0,0-9.83-9.84m0,21.17A11.33,11.33,0,1,1,22.66,11.33,11.35,11.35,0,0,1,11.33,22.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.63,9.32A1.41,1.41,0,1,0,6.22,7.91,1.41,1.41,0,0,0,7.63,9.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15,9.32a1.41,1.41,0,1,0-1.41-1.41A1.41,1.41,0,0,0,15,9.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.52,13.67a6.22,6.22,0,0,0,6.12,4.23,6.85,6.85,0,0,0,6.11-4.23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.73ef41fd.svg";
export { ForwardRef as ReactComponent };